import BestVarieties from '../../../components/BestVarieties';

import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { queryClient } from '@js/api';
import ErrorBoundary from '@components/OADManagment/components/Dashboard/ErrorBoundaries/ErrorBoundaries';
import { IntlProvider } from 'react-intl';
import messages, { locale } from '@js/intl';

export async function systemeExpert() {
  const node = document.getElementById('systemeExpert');

  if (node) {
    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale={locale} messages={messages[locale]}>
          <ErrorBoundary>
            <Suspense fallback="">
              <BestVarieties specie={window.DEFAULT_SELECTED_SPECIE} />
            </Suspense>
          </ErrorBoundary>
        </IntlProvider>
      </QueryClientProvider>,
      node
    );
  }
}

systemeExpert();
